export default "__VITE_ASSET__CTiEq0LZ__"